import { memo as Memo } from 'react';

//* Components
import Container from 'components/common/Container';
import Button from 'components/common/Button';
import Text from 'components/common/Text';
import Image from 'components/common/Image';
import Icon from 'components/common/Icon';

//* Style
import HeroSectionStyle from './style';

const Hero = Memo(({ title, image, url, type, date, place, time, text }) => {
	return (
		<HeroSectionStyle className={`${type === 'event' ? 'event-background' : ''}`}>
			<Container>
				<Button
					url={url}
					text={`backToNews`}
					btnType={`with-lottie`}
					className={`back-button`}
				/>

				{type === 'news' ? (
					<>
						<Container
							row
							full
							className={`type-and-title-wrapper align-center`}>
							<div className={`col-2 col-t-1`} />

							<div className={`col-8 col-t-10 col-ts-12 col-m-12`}>
								<Text
									tag={`span`}
									className={`p p3 notoSans-medium primary-color9 secondary-color8-bg individual-type`}
									text={`news`}
								/>

								<Text
									tag={`h1`}
									className={`h4 minion3-medium primary-color9 uppercase individual-title`}
									text={title}
								/>
							</div>

							<div className={`col-2 col-t-1`} />
						</Container>

						<Image
							src={image?.src}
							alt={image?.alt}
							className={'contain'}
						/>
					</>
				) : (
					<Container
						row
						full
						className={`event-hero-section`}>
						<div className={`empty col-1 col-t-12 col-ts-12 col-m-12`} />

						<div className={`event-hero-image col-4 col-t-5 col-ts-12 col-m-12`}>
							<Image
								src={image?.src}
								alt={image?.alt}
							/>
						</div>

						<div className={`event-hero-info col-6 col-t-7 col-ts-12 col-m-12`}>
							<div className={`event-internal`}>
								<div className={`event-content`}>
									<Text
										tag={`h1`}
										className={`h5 minion3-medium primary-color9 uppercase`}
										text={title}
									/>

									<Text
										tag={`p`}
										className={`p p4 notoSans-regular primary-color9 event-hero-text`}
										text={text}
									/>

									<div className={`event-banner`}>
										<div className={`left-part`}>
											<Icon
												name={`time`}
												className={`p p1`}
											/>

											<div className={`date-time`}>
												<Text
													tag={`p`}
													className={`p p2 minion3-medium primary-color9 uppercase`}
													text={date}
												/>

												<Text
													tag={`p`}
													className={`p p2 minion3-medium primary-color9`}>
													{time[0]}&nbsp;-&nbsp;{time[1]}
												</Text>
											</div>
										</div>

										<div className={`right-part`}>
											<Icon
												name={`location`}
												className={`p p1`}
											/>

											<Text
												tag={`p`}
												className={`p p2 minion3-medium primary-color9 uppercase`}
												text={place}
											/>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div className={`empty col-1 col-t-12 col-ts-12 col-m-12`} />
					</Container>
				)}
			</Container>
		</HeroSectionStyle>
	);
});

export default Hero;
